import { JSX } from 'react'

import { cn } from '~/utils/tailwind-utils'

export const LoadingIndicator = ({
  fullScreen = true,
  fullHeight = false,
}: {
  fullScreen?: boolean
  fullHeight?: boolean
}): JSX.Element => {
  return (
    <div
      className={cn('flex flex-col items-center justify-center', {
        'h-dvh w-full': fullScreen,
        'h-full w-full py-16': !fullScreen,
        'h-dvh': fullHeight,
      })}
    >
      <img
        src="/logo_light.svg"
        className="block h-28 w-28 animate-pulse opacity-20 dark:hidden"
      />
      <img
        src="/logo_dark.svg"
        className="hidden h-28 w-28 animate-pulse opacity-20 dark:block"
      />
    </div>
  )
}
